import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { Tooltip } from '@bluebeam/react-skyline-tooltip';
const getFirstLetter = (word) => {
    const firstLetter = word[0].substring(0, 1).toUpperCase();
    return firstLetter;
};
/**
 * Indicator is a type of **molecule** that represent user by a circular indicator
 */
const Indicator = ({ className, firstName, lastName, onClick, toolTip, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    const handleKeydown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            onClick(e);
        }
    };
    const showIndicator = () => {
        return (_jsx("span", { className: buildClassName('flex items-center justify-center border-none', 'skyline-text-body-2 text-center text-white', 'h-8 w-8 cursor-default rounded-[20.67px] p-0 leading-8', className), onClick: (e) => {
                e.stopPropagation();
                if (onClick)
                    onClick(e);
            }, onKeyDown: handleKeydown, role: "button", tabIndex: 0, ...dataAttributes, children: `${getFirstLetter(firstName)}${getFirstLetter(lastName)}` }));
    };
    return (_jsxs(_Fragment, { children: [toolTip && (_jsx(Tooltip, { label: `${firstName} ${lastName}`, placement: "Bottom", children: showIndicator() })), !toolTip && showIndicator()] }));
};
export default Indicator;
//# sourceMappingURL=Indicator.js.map